import React from 'react'

const WarningFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22ZM11 13V7H13V13H11ZM11 15V17H13V15L11 15Z" fill="#EB5164"/>
  </svg>
)

export default WarningFilled